import React, { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import MainApp from "./MainApp";
import SignIn from "./SignIn";
// import SignUp from "./SignUp";
import Condition from './Condition';
import { deleteAllCookies } from "../../DataServices/Utils";
import { useToasts } from "react-toast-notifications";
import ApiGateway from "../../DataServices/DataServices";
import {sessionStorageRemoveItem} from "../../DataServices/Utils"
var isLogin = Condition();
const RestrictedRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
    {...rest}
    render={props =>
      isLogin
        ? <Component {...props} />
        : <Redirect
          to={{
            pathname: '/signin',
            state: { from: props.location }
          }}
        />}
    />
  )  
}  

const App = (props) => {
  const { addToast } = useToasts();
  const applyToast = (msg,type) => { return addToast(msg, { appearance: type });}

  /* useEffect(()=>{
    window.onbeforeunload = function () {
      logoutUser()
  }
 },[]) */
  useEffect(() => {
    let timer = null;
    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        logoutUser();
      }, 300000);
      
    };
    document.addEventListener("mousemove", resetTimer);
    document.addEventListener("keypress", resetTimer);
    return () => {
      document.removeEventListener("mousemove", resetTimer);
      document.removeEventListener("keypress", resetTimer);
    };
  }, []);
  const logoutUser = () => {
    ApiGateway.post("/merchant/logout", {}, (response) => {
      if (response.success) {
        applyToast(response.message,"success")
        deleteAllCookies()
        sessionStorageRemoveItem("auth_merchant_id");
        sessionStorageRemoveItem("MerchantAuthPayout");
        window.location.href = `/signin`;
      } else {
        applyToast(response.message,"error")
      }
    });
  };
  const {match , location} = props;
if (location.pathname === '/') {
    if (!isLogin) {
      return (<Redirect to={'/signin'} />);
    } else  {
      return (<Redirect to={'/dashboard'} />);
    } 
  } 
  if (location.pathname === "/signup") {
    if (isLogin) {
      return <Redirect to={"/signin"} />;
    }
  }
  return (
      <Switch>
          <Route exact path='/signin' component={SignIn} />
          {/* <Route exact path='/signup' component={SignUp} /> */}
          <RestrictedRoute path={`${match.url}`} component={MainApp} />
      </Switch>  
  )
}

export default App;
